class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-drawer-product' || event.source === 'cart-drawer-items') {
          return;
        }
        const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        fetch(`${cartUrl}?section_id=cart-drawer`)
          .then((res) => res.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newDrawer = html.querySelector('cart-drawer');
            const newInner = html.querySelector('.drawer__inner');
            const currentInner = this.querySelector('.drawer__inner');
            if (newDrawer) {
              this.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
            }
            if (newInner && currentInner) {
              currentInner.innerHTML = newInner.innerHTML;
              currentInner.className = newInner.className;
            }
            if (typeof initCartSwiper === 'function') {
              setTimeout(() => {
                initCartSwiper();
              }, 100);
            }
          })
          .catch((err) => console.error(err));
      });
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      if (typeof initCartSwiper === 'function') {
        initCartSwiper();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('click', function (e) {
  const button = e.target.closest('.cart-product-collections button.add_to_cart');
  if (!button) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = button.dataset.variantId || button.getAttribute('data-variant-id');
  const productId = button.dataset.productId || button.getAttribute('data-product-id');
  if (!variantId) return;

  const quantity = parseInt(button.dataset.itemQuantity || 1, 10);

  button.classList.add('loading');
  button.setAttribute('aria-disabled', 'true');

  const cartDrawer = document.querySelector('cart-drawer');
  const sectionsToRender = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];

  const body = JSON.stringify({
    id: variantId,
    quantity: quantity,
    sections: sectionsToRender,
    sections_url: window.location.pathname
  });

  const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

  fetch(addUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/javascript'
    },
    body: body
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) {
        console.error('Error adding drawer product to cart:', data.description || data.message);
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        return;
      }

      console.log('Added to cart via drawer successfully:', data);

      if (cartDrawer && data.sections) {
        cartDrawer.renderContents(data);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-drawer-product',
          cartData: data,
          variantId: variantId
        });
      }

      if (typeof initCartSwiper === 'function') {
        setTimeout(() => {
          initCartSwiper();
        }, 300);
      }
    })
    .catch((err) => {
      console.error('Error adding drawer product to cart:', err);
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
    });
});
